export const CompanyProfileBannerImageSvg = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.6047 54.2376L31.6048 54.2377L41.2524 44.5897L32.7653 36.1025L27.2559 41.6121L35.7429 50.0992L31.6047 54.2376Z"
      fill="#D2D7DF"
    />
    <path
      d="M51.4008 54.7389L45.8916 60.248L54.3788 68.7352L59.888 63.2261L51.4008 54.7389Z"
      fill="#D2D7DF"
    />
    <path
      d="M45.8912 60.2475L36.2432 69.8948C34.8878 71.2503 33.0861 71.9966 31.1692 71.9966C29.2527 71.9966 27.4507 71.2503 26.0952 69.8951C23.2976 67.0972 23.2976 62.545 26.0956 59.7471L31.6046 54.2379L35.7429 50.0995L27.2558 41.6124L17.608 51.2599C10.1307 58.7376 10.1307 70.9047 17.6077 78.3823C21.2302 82.0048 26.0465 83.9999 31.1692 83.9999C36.2922 83.9999 41.1083 82.0048 44.7308 78.3823L50.2399 72.8731L54.3784 68.7347L45.8912 60.2475Z"
      fill="#EE399E"
    />
    <path
      d="M77.8514 48.9627C77.5632 48.9627 77.275 48.8524 77.0553 48.6324L74.3289 45.9004C73.8898 45.4606 73.8905 44.7483 74.3303 44.3096C74.7698 43.8701 75.4817 43.8709 75.9211 44.3111L78.6476 47.043C79.0867 47.4828 79.0859 48.1951 78.6461 48.6338C78.4264 48.8532 78.1389 48.9627 77.8514 48.9627Z"
      fill="#FDC221"
    />
    <path
      d="M50.882 21.9937C50.5945 21.9937 50.3066 21.8842 50.0873 21.6648L47.3557 18.938C46.9159 18.4989 46.9152 17.7866 47.3543 17.3472C47.7926 16.9074 48.5053 16.9059 48.9451 17.3457L51.6766 20.0725C52.1165 20.5116 52.1172 21.2239 51.6781 21.6634C51.4584 21.8835 51.1702 21.9937 50.882 21.9937Z"
      fill="#FDC221"
    />
    <path
      d="M75.125 21.9934C74.8372 21.9934 74.5493 21.8835 74.3296 21.6638C73.8901 21.2247 73.8901 20.5124 74.3296 20.073L77.056 17.3462C77.4948 16.9067 78.2074 16.9067 78.6468 17.3462C79.0863 17.7853 79.0863 18.4976 78.6468 18.937L75.9204 21.6638C75.7011 21.8835 75.4129 21.9934 75.125 21.9934Z"
      fill="#FDC221"
    />
    <path
      d="M48.1504 48.9634C47.8626 48.9634 47.5747 48.8535 47.355 48.6338C46.9155 48.1947 46.9155 47.4824 47.355 47.043L50.0865 44.311C50.5253 43.8716 51.2379 43.8716 51.6774 44.311C52.1168 44.7501 52.1168 45.4624 51.6774 45.9019L48.9458 48.6338C48.7264 48.8535 48.4382 48.9634 48.1504 48.9634Z"
      fill="#FDC221"
    />
    <path
      d="M84.0012 34.1289H80.1436C79.5221 34.1289 79.0186 33.6254 79.0186 33.0039C79.0186 32.3824 79.5221 31.8789 80.1436 31.8789H84.0012C84.6227 31.8789 85.1262 32.3824 85.1262 33.0039C85.1262 33.6254 84.6227 34.1289 84.0012 34.1289Z"
      fill="#FDC221"
    />
    <path
      d="M45.8577 34.1289H42C41.3785 34.1289 40.875 33.6254 40.875 33.0039C40.875 32.3824 41.3785 31.8789 42 31.8789H45.8577C46.4791 31.8789 46.9827 32.3824 46.9827 33.0039C46.9827 33.6254 46.4791 34.1289 45.8577 34.1289Z"
      fill="#FDC221"
    />
    <path
      d="M63.001 16.9827C62.3795 16.9827 61.876 16.4791 61.876 15.8577V12C61.876 11.3785 62.3795 10.875 63.001 10.875C63.6224 10.875 64.126 11.3785 64.126 12V15.8577C64.126 16.4791 63.6224 16.9827 63.001 16.9827Z"
      fill="#FDC221"
    />
    <path
      d="M63.001 55.1252C62.3795 55.1252 61.876 54.6217 61.876 54.0002V50.1426C61.876 49.5211 62.3795 49.0176 63.001 49.0176C63.6224 49.0176 64.126 49.5211 64.126 50.1426V54.0002C64.126 54.6217 63.6224 55.1252 63.001 55.1252Z"
      fill="#FDC221"
    />
    <path
      d="M74.5928 36.3848L70.8125 31.3201L72.8411 25.3366C73.2988 23.9886 72.0112 22.7009 70.6632 23.1587L70.6663 23.1619L64.6828 25.1904L59.6181 21.4101C58.4767 20.5612 56.8553 21.3879 56.8711 22.809L56.9506 29.1264L51.7905 32.7731C50.6269 33.5935 50.9131 35.393 52.2706 35.8158L58.305 37.6916L60.1808 43.726C60.6037 45.0835 62.4033 45.3697 63.2235 44.2061L66.8702 39.046L73.194 39.1319C73.7257 39.139 74.1734 38.9169 74.4823 38.577L74.4889 38.5704C75.0022 37.9993 75.1247 37.0993 74.5928 36.3848Z"
      fill="#FDC221"
    />
  </svg>
);
